import { render, staticRenderFns } from "./AccountingPeriodShow.vue?vue&type=template&id=87a389f6&scoped=true"
import script from "./AccountingPeriodShow.vue?vue&type=script&lang=js"
export * from "./AccountingPeriodShow.vue?vue&type=script&lang=js"
import style0 from "./AccountingPeriodShow.vue?vue&type=style&index=0&id=87a389f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a389f6",
  null
  
)

export default component.exports